import Home from './components/home/Home';
import Projects from './components/home/Projects';
import Contact from './components/home/Contact';

// Routes
export const routes: Array<[string, React.FC]> = [
  ['/', Home],
  ['/projects', Projects],
  ['/contactme', Contact],
];
